import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import { type IdConfiguration } from "../redux/settings.types.ts"

const BASE_URL = "/user/id-configuration"

const PATHS = {
  idConfiguration: `${BASE_URL}/`
}

type IdConfigurationPatch = Partial<
  Pick<IdConfiguration, "mode" | "start_from">
>

export const getIdConfiguration = (): Promise<ApiResponse<IdConfiguration>> =>
  request.api.get(PATHS.idConfiguration)

export const updateIdConfiguration = (
  payload: IdConfigurationPatch
): Promise<ApiResponse<IdConfiguration>> =>
  request.api.patch(PATHS.idConfiguration, payload)
